/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
  FormLabel,
  FormGroup,
} from "react-bootstrap";
import { Formik } from "formik";
import "./PartyOrders.scss";

import { OrderCard } from "../../../assets/elements/cards";
import PageLoader from "../../../assets/elements/loaders/PageLoader";
import { PrimaryButton } from "../../../assets/elements/buttons";
import CommonServices from "../../../services/CommonServices";
import validate from "../../../validations";
import Input from "../../../assets/elements/formElements/adminInput/AdminInput";
import VendorServices from "../../../services/Vendorservices";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import SimpleBar from "simplebar-react";
import moment from "moment";
import formatters from "../../../assets/numberFormatter";
import AsyncSelect from "react-select/async";
import { debounce, each, set } from "lodash";
import Head from "../../../assets/elements/Head";
import AdminServices from "../../../services/AdminServices";

export default function PartyOrders() {
  const [pageLoading, setPageLoading] = useState(false);
  const [partyOrders, setPartyOrders] = useState([]);
  const [quotationModal, setQuotationModal] = useState(false);
  const [quotationLoading, setQuotationLoading] = useState(false);
  const [selectedPartyOrder, setSelectedPartyOrder] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("ACTIVE");
  const [searchTerm, setSearchTerm] = useState("");
  // Add these to existing state variables
  const [hostDetailsModal, setHostDetailsModal] = useState(false);
  const [customerDetailsModal, setCustomerDetailsModal] = useState(false);
  const [selectedHost, setSelectedHost] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [paymentsModal, setPaymentsModal] = useState(false);
  const [paymentDistributions, setPaymentDistributions] = useState([]);

  const [partyOrderStats, setPartyOrderStats] = useState({
    DELIVERED: 0,
    PENDING: 0,
    ACCEPTED: 0,
    "NOT-FULFILLED": 0,
  });
  const [openStats, setOpenStats] = useState({ ACTIVE: 0, "NOT-FULFILLED": 0 });
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [restaurantId, setRestaurantId] = useState(""); // Start with empty for "All"
  const [selectedRestaurant, setSelectedRestaurant] = useState({ label: "All Restaurants", value: "all" });
  const [inputValue, setInputValue] = useState("");
  const [infiniteLoading, setInfiniteLoading] = useState(false);
  const [partyOrderTotal, setPartyOrderTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [pricings, setPricings] = useState([
    {
      id: 1,
      priceType: "",
      amount: "",
    },
  ]);

  const orderTimeline = [
    { orderStatus: "Placed", time: "2:00 PM" },
    { orderStatus: "Accepted", time: "2:03 PM" },
  ];
  const userId = useSelector((state) => state.auth.userId);
  const config = useSelector((state) => state.config.config);

  let partyOrderInterval = useRef(null);
  useEffect(() => {
    getRestaurantPartyOrders(selectedStatus, "reload");

    if (config.source === "admin") {
      getRestaurants("reload", "");
      getPartyOrderStats("");
    }
    if (config.source === "vendor") {
      getPartyOrderStats(userId);
      setRestaurantId(userId);
    }
    getOpenPartyOrderStats();
    // partyOrderInterval.current = setInterval(
    //   getPartyOrderOnIntervals,
    //   10000,
    //   selectedStatus,
    //   1
    // );
    // return () => {
    //   clearInterval(partyOrderInterval.current);
    // };
  }, []);

  //functions
  const onQuotationModal = (selectedPartyOrder) => {
    if (selectedPartyOrder) {
      setSelectedPartyOrder(selectedPartyOrder);
    } else {
      setSelectedPartyOrder("");
    }
    setPricings([
      {
        id: 1,
        priceType: "",
        amount: "",
      },
    ]);
    setQuotationModal(!quotationModal);
  };

  const onStatusChange = (status) => {
    if (!restaurantId || restaurantId === "" || status === "ACTIVE") {
      getRestaurantPartyOrders(status, "reload", 1);
    } else {
      getQuotationsOnStatus(status, "reload", restaurantId, 1);
    }
    setPage(1);
    setSelectedStatus(status);
  };

  // const getPartyOrderOnIntervals = (status, restaurantId) => {
  //   if (!restaurantId || status === "ACTIVE") {
  //     getRestaurantPartyOrders(status, "refresh");
  //   } else {
  //     getQuotationsOnStatus(status, "refresh", restaurantId);
  //   }
  // };

  const onRestaurantChange = (selected) => {
    if (selected && selected.value === "all") {
      // Handle "All" selection
      setSelectedRestaurant(selected);
      setRestaurantId(""); // Clear restaurantId to show all restaurants
      getPartyOrderStats(""); // Get stats for all restaurants
      getRestaurantPartyOrders(selectedStatus, "refresh", 1); // Get all party orders
    } else {
      setSelectedRestaurant(selected);
      setRestaurantId(selected.value);
      getPartyOrderStats(selected.value);
      getQuotationsOnStatus(selectedStatus, "refresh", selected.value, 1);
    }
    setPage(1);
  };

  const handleViewPayments = async (order) => {
    try {
      setPageLoading(true);
      const res = await AdminServices.getPaymentDistributions({ partyOrder_id: order._id, resource: "party_order" });
      setPageLoading(false);
      if (res.data.success) {
         setPaymentDistributions(res.data.data);
         setSelectedPartyOrder(order);
         setPaymentsModal(true);
      } else {
         toast.error(res.data.message || "Failed to fetch payments");
      }
    } catch(err) {
      setPageLoading(false);
      toast.error("Error fetching payments");
    }
  };

  const handleApproveOfflinePayment = async (distId) => {
    try {
      setPageLoading(true);
      const res = await AdminServices.confirmOfflinePayment({
          partyOrder_id: selectedPartyOrder._id,
          distribution_id: distId,
          payment_status: 'PAID'
      });
      setPageLoading(false);
      if (res.data.success) {
         toast.success("Payment confirmed");
         setPaymentsModal(false);
         if (!restaurantId || selectedStatus === "ACTIVE") {
           getRestaurantPartyOrders(selectedStatus, "reload", 1);
         } else {
           getQuotationsOnStatus(selectedStatus, "reload", restaurantId, 1);
         }
      } else {
         toast.error(res.data.message || "Failed to confirm payment");
      }
    } catch(err) {
      setPageLoading(false);
      toast.error("Error confirming payment");
    }
  };

  const handleInputChange = (newValue) => {
    const inputValue = newValue.replace(/\W/g, "");
    setInputValue(inputValue);
    return inputValue;
  };

  const onRestaurantsOptions = useCallback(
    debounce((inputText, callback) => {
      getRestaurants("refresh", inputText, callback);
    }, 1000),
    []
  );

  const onStatusModal = (selected) => {
    console.log(selected);
    if (selected) setSelectedPartyOrder(selected);
    else setSelectedPartyOrder("");
    setUpdateStatusModal(!updateStatusModal);
  };

  const onLoadMore = () => {
    if (!restaurantId || selectedStatus === "ACTIVE") {
      getRestaurantPartyOrders(selectedStatus, "refresh", page + 1);
    } else {
      getQuotationsOnStatus(selectedStatus, "refresh", restaurantId, page + 1);
    }
    setPage(page + 1);
  };

  const onPriceTypeChange = (e, setFieldValue, name, id) => {
    let updatedPricings = pricings.map((eachPricing) => {
      if (eachPricing.id === id) {
        return {
          ...eachPricing,
          [name]: e.target.value,
        };
      } else {
        return eachPricing;
      }
    });
    setPricings(updatedPricings);
    setFieldValue("pricings", updatedPricings);
  };

  const onAddPriceType = (setFieldValue) => {
    let updatedPricings = pricings;
    let temp = {
      priceType: "",
      amount: "",
      id: Math.random() * 100,
    };
    updatedPricings.push(temp);
    setPricings(updatedPricings);
    setFieldValue("pricings", updatedPricings);
  };

  const onRemovePriceType = (eachPricing, setFieldValue) => {
    let updatedPricings = pricings.filter(
      (pricing) => pricing.id !== eachPricing.id
    );
    setPricings(updatedPricings);
    setFieldValue("pricings", updatedPricings);
  };

  //Apis
  const getRestaurantPartyOrders = (status, reload, page) => {
    reload === "reload" ? setPageLoading(true) : setInfiniteLoading(true);
    const details = {
      resource: "party_order",
      status: status,
      page,
      limit: 10,
    };
    axios
      .all([CommonServices.getPartyOrdersByStatus(details)])
      .then(function (res) {        
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let ordersData = resData.data ? resData.data : {};
            let partyOrderTotal = ordersData.total ? ordersData.total : 0;
            setPartyOrderTotal(partyOrderTotal);
            ordersData = ordersData.data ? ordersData.data : [];
            ordersData = ordersData.map((eachOrder) => {
              let matched = false;
              let quotationStatus = "";
              eachOrder.quotations &&
                eachOrder.quotations.map((eachQuo) => {
                  if (eachQuo.restaurant === userId) {
                    matched = true;
                    quotationStatus = eachQuo.status;
                  }
                });
              return {
                ...eachOrder,
                matched,
                quotationStatus,
              };
            });
            reload === "reload"
              ? setPartyOrders(ordersData)
              : setPartyOrders([...partyOrders, ordersData]);
            setInfiniteLoading(false);
            setPageLoading(false);
          } else {
            setPageLoading(false);
            setInfiniteLoading(true);
          }
        } else {
          setPageLoading(false);
          setInfiniteLoading(true);
        }
      })
      .catch(function (res) {
        if (res) console.log("Error occured in fetching orders");
      });
  };

  const getQuotationsOnStatus = (status, reload, restaurantId, page) => {
    reload === "reload" ? setPageLoading(true) : setInfiniteLoading(true);
    const details = {
      resource: "party_order_quotation",
      status: status,
      restaurant_id: restaurantId,
      page,
      limit: 10,
    };
    axios
      .all([VendorServices.getQuotationsOnStatus(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let ordersData = resData.data ? resData.data : {};
            let partyOrderTotal = ordersData.total ? ordersData.total : 0;
            setPartyOrderTotal(partyOrderTotal);
            ordersData = ordersData.data ? ordersData.data : [];
            console.log("getQuotationsOnStatus", ordersData);

            ordersData = ordersData.map((eachOrder) => {
              // Ensure we have proper restaurant data in quotations
              const quotations = eachOrder.quotations || [];
              const matchedQuotation = quotations.find(quotation =>
                quotation.restaurant?._id === userId || quotation.restaurant === userId
              );

              return {
                ...eachOrder,
                ...eachOrder.partyOrder, // Spread partyOrder details
                quotationId: eachOrder._id,
                matched: !!matchedQuotation,
                quotationStatus: eachOrder.status,
                // Ensure quotations array is properly structured
                quotations: quotations.map(quotation => ({
                  ...quotation,
                  restaurant: quotation.restaurant || eachOrder.restaurant,
                  // Make sure restaurant object has _id
                  ...(quotation.restaurant && typeof quotation.restaurant === 'object' ? {} : {
                    restaurant: {
                      _id: restaurantId,
                      store_name: quotation.restaurant?.store_name || 'Unknown',
                      primary_mobile_number: quotation.restaurant?.primary_mobile_number || 'N/A'
                    }
                  })
                }))
              };
            });

            reload === "reload"
              ? setPartyOrders(ordersData)
              : setPartyOrders([...partyOrders, ...ordersData]);
            setInfiniteLoading(false);
            setPageLoading(false);
          } else {
            setInfiniteLoading(false);
            setPageLoading(false);
          }
        } else {
          setInfiniteLoading(false);
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        if (res) console.log("Error occured in fetching orders");
      });
  };

  const addQuotation = (values) => {
    setQuotationLoading(true);
    let amount = 0;
    let pricings =
      values.pricings && values.pricings.length > 0
        ? values.pricings.map((eachPrice) => {
          amount += +eachPrice.amount;
          return {
            amount: eachPrice.amount,
            type: eachPrice.priceType,
          };
        })
        : [];
    const details = {
      resource: "party_order_quotation",
      partyOrder: selectedPartyOrder._id,
      restaurant: userId,
      amount,
      description: values.description,
      details: JSON.stringify(pricings),
    };
    axios
      .all([VendorServices.addQuotation(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData.message;
          if (resData.success) {
            toast.success("Quotation added Successfully");
            setQuotationLoading(false);
            onQuotationModal("");
            getRestaurantPartyOrders(selectedStatus, "refresh", 1);
            getPartyOrderStats(restaurantId);
            getOpenPartyOrderStats();
          } else {
            setQuotationLoading(false);
            toast.error(message);
          }
        } else {
          setQuotationLoading(false);
        }
      })
      .catch(function (res) {
        if (res) console.log("Error occured in fetching orders");
      });
  };

  const getPartyOrderStats = (restaurantId) => {
    const qDetails = {
      resource: "party_order_quotation",
      restaurant_id: restaurantId,
    };
    axios
      .all([CommonServices.getPartyQuotationStats(qDetails)])
      .then(function (res) {
        if (res[0]) {
          let orderResData = res[0];
          if (orderResData.success) {
            let orderStats = orderResData.data ? orderResData.data : {};
            orderStats = orderStats.data ? orderStats.data : [];
            console.log("PartyorderStats", orderStats);
            let stats = { DELIVERED: 0, PENDING: 0, ACCEPTED: 0, ACTIVE: 0, "NOT-FULFILLED": 0 };
            orderStats.map((eachstat) => {
              stats[eachstat._id] = eachstat.count;
            });

            setPartyOrderStats({ ...stats });
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        if (res) console.log("Error occured in fetching party order stats");
      });
  };

  const getOpenPartyOrderStats = () => {
    const qDetails = {
      resource: "party_order",
    };
    axios
      .all([CommonServices.getPartyOrderStats(qDetails)])
      .then(function (res) {
        if (res[0] || res[1]) {
          let orderResData = res[0];
          if (orderResData.success) {
            let orderStats = orderResData.data ? orderResData.data : {};
            orderStats = orderStats.data ? orderStats.data : [];
            console.log("orderStats", orderStats);

            let stats = { DELIVERED: 0, PENDING: 0, ACCEPTED: 0, ACTIVE: 0, "NOT-FULFILLED": 0 };
            orderStats.map((eachstat) => {
              stats[eachstat._id] = eachstat.count;
            });

            setOpenStats({ ...stats });
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        if (res) console.log("Error occured in fetching party order stats");
      });
  };

  const getRestaurants = (reload, term, callback) => {
    const details = {
      status: "APPROVED",
      resource: "restaurant",
      search_string: term,
    };
    axios
      .all([CommonServices.getRestaurantsBySearch(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let restaurants = resData.data ? resData.data : {};
            restaurants = restaurants.data ? restaurants.data : [];

            restaurants = restaurants.map((eachRes) => {
              return {
                ...eachRes,
                label: eachRes.store_name,
                value: eachRes._id,
              };
            });

            // Add "All" option at the beginning
            const optionsWithAll = [
              { label: "All Restaurants", value: "all" },
              ...restaurants
            ];

            if (callback) {
              callback(optionsWithAll);
            }
            if (restaurants.length > 0 && reload === "reload") {
              setDefaultOptions(optionsWithAll);
            }
            setRestaurants(optionsWithAll);
          } else {
            // Even if API fails, ensure "All" option is available
            const allOption = [{ label: "All Restaurants", value: "all" }];
            if (callback) callback(allOption);
            if (reload === "reload") setDefaultOptions(allOption);
            setRestaurants(allOption);
          }
        } else {
          // Handle case when no response
          const allOption = [{ label: "All Restaurants", value: "all" }];
          if (callback) callback(allOption);
          if (reload === "reload") setDefaultOptions(allOption);
          setRestaurants(allOption);
        }
      })
      .catch(function (res) {
        console.log(res);
        // On error, still provide "All" option
        const allOption = [{ label: "All Restaurants", value: "all" }];
        if (callback) callback(allOption);
        if (reload === "reload") setDefaultOptions(allOption);
        setRestaurants(allOption);
      });
  };


  const deliveredPartyOrderQuotation = (values) => {
    setQuotationLoading(true);
    const details = {
      resource: "party_order_quotation",
      partyOrderQuotation_id: selectedPartyOrder.quotationId,
      status: "DELIVERED",
    };
    axios
      .all([VendorServices.deliveredPartyOrderQuotation(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData.message;
          if (resData.success) {
            toast.success(
              "party order status changed to delivered Successfully"
            );
            getQuotationsOnStatus(selectedStatus, "reload", restaurantId, 1);
            getPartyOrderStats(restaurantId);
            onStatusModal("");
            setQuotationLoading(false);
          } else {
            setQuotationLoading(false);
            toast.error(message);
          }
        } else {
          setQuotationLoading(false);
        }
      })
      .catch(function (res) {
        if (res)
          console.log("Error occured in changing party order delivered status");
      });
  };

  const viewHostDetails = (order) => {
    let host = null;

    console.log('Selected Restaurant ID:', restaurantId);
    console.log('Order Quotations:', order.quotations);

    if (config.source === "admin") {
      if (restaurantId && restaurantId !== "all") {
        // Specific restaurant selected
        const restaurantQuotation = order.quotations?.find(quotation => {
          const quotationRestaurantId = quotation.restaurant?._id || quotation.restaurant;
          return quotationRestaurantId === restaurantId;
        });
        host = restaurantQuotation?.restaurant;
      } else {
        // "All" selected - show the first available host
        host = order.quotations?.[0]?.restaurant;
      }
    } else {
      // For vendor view
      host = order.quotations?.[0]?.restaurant;
    }

    if (host) {
      setSelectedHost(host);
      setHostDetailsModal(true);
    } else {
      toast.error("No host details available for this order");
    }
  };

  console.log(selectedHost);





  const viewCustomerDetails = (order) => {
    const customer = {
      // Personal Information
      name: order.customer?.name || order.name || 'N/A',
      mobile_no: order.mobile_no || 'N/A',
      email_address: order.email_address || 'N/A',

      // Order Information
      sequence_no: order.sequence_no || 'N/A',
      type: order.type || 'N/A',
      number_of_persons: order.number_of_persons || 'N/A',
      status: order.status || 'N/A',
      payment_status: order.payment_status || 'N/A',
      date: order.date || 'N/A',
      delivery_instructions: order.delivery_instructions || 'N/A',

      // Timestamps
      createdAt: order.createdAt || 'N/A',
      updatedAt: order.updatedAt || 'N/A',

      // Menu Details
      menu: order.menu || [],

      // Quotation Details
      quotations: order.quotations || [],

      // Complete Address Object
      address: order.address ? {
        full_address: order.address.full_address || 'N/A',
        house_no: order.address.house_no || 'N/A',
        building_name: order.address.building_name || 'N/A',
        street_name: order.address.street_name || 'N/A',
        land_mark: order.address.land_mark || 'N/A',
        area: order.address.area || 'N/A',
        city: order.address.city || 'N/A',
        county: order.address.county || 'N/A',
        state: order.address.state || 'N/A',
        pincode: order.address.pincode || 'N/A',
        type_of_address: order.address.type_of_address || 'N/A',
        phone_number: order.address.phone_number || 'N/A',
        status: order.address.status || 'N/A',
        location: order.address.location || {},
        latitude: order.address.latitude || 'N/A',
        longitude: order.address.longitude || 'N/A',
        createdAt: order.address.createdAt || 'N/A',
        updatedAt: order.address.updatedAt || 'N/A',
        _id: order.address._id || 'N/A'
      } : null,

      // Customer Reference
      customer_id: order.customer || 'N/A',

      // MongoDB ID
      _id: order._id || 'N/A',

      // Version Key
      __v: order.__v || 0,

      // Spread any additional customer properties
      ...order.customer,
      ...order
    };

    setSelectedCustomer(customer);
    setCustomerDetailsModal(true);
  };

  const filteredOrders = partyOrders.filter(order =>
    searchTerm === "" ||
    order.sequence_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    order.quotations?.some(quotation =>
      quotation.restaurant?.store_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      quotation.restaurant?.primary_mobile_number?.includes(searchTerm)
    )
  );




  return (
    <div className="orders-main-div">
      <Head title="Party Orders" />
      <div className="order-card-flex">
        {config.source === "admin" && (
          <div className="search-and-select-container">
            <AsyncSelect
              className="resto-react-select"
              placeholder="Select Host"
              onChange={onRestaurantChange}
              defaultOptions={defaultOptions}
              value={selectedRestaurant}
              loadOptions={onRestaurantsOptions}
              onInputChange={handleInputChange}
            />
          </div>
        )}
        {restaurantId && (
          <>
            <OrderCard
              orderCardtext="Active"
              orderSubcardContent={partyOrders ? partyOrders.length : 0}
              style={{
                marginRight: "40px",
                cursor: "pointer",
                ...(selectedStatus === "ACTIVE" && {
                  borderColor: "var(--theme-primary-color)",
                  color: "var(--theme-primary-color)",
                }),
              }}
              onClick={() => onStatusChange("ACTIVE")}
            />
            <OrderCard
              orderCardtext="Pending"
              orderSubcardContent={partyOrderStats.PENDING}
              style={{
                marginRight: "40px",
                cursor: "pointer",
                ...(selectedStatus === "PENDING" && {
                  borderColor: "var(--theme-primary-color)",
                  color: "var(--theme-primary-color)",
                }),
              }}
              onClick={() => onStatusChange("PENDING")}
            />
            <OrderCard
              orderCardtext="Accepted"
              orderSubcardContent={partyOrderStats.ACCEPTED}
              style={{
                marginRight: "40px",
                cursor: "pointer",
                ...(selectedStatus === "ACCEPTED" && {
                  borderColor: "var(--theme-primary-color)",
                  color: "var(--theme-primary-color)",
                }),
              }}
              onClick={() => onStatusChange("ACCEPTED")}
            />
            <OrderCard
              orderCardtext="Delivered"
              orderSubcardContent={partyOrderStats.DELIVERED}
              style={{
                marginRight: "40px",
                cursor: "pointer",
                ...(selectedStatus === "DELIVERED" && {
                  borderColor: "var(--theme-primary-color)",
                  color: "var(--theme-primary-color)",
                }),
              }}
              onClick={() => onStatusChange("DELIVERED")}
            />
            <OrderCard
              orderCardtext="Not Fulfilled"
              orderSubcardContent={partyOrderStats["NOT-FULFILLED"] || openStats["NOT-FULFILLED"] || 0}
              style={{
                marginRight: "40px",
                cursor: "pointer",
                ...(selectedStatus === "NOT-FULFILLED" && {
                  borderColor: "var(--theme-primary-color)",
                  color: "var(--theme-primary-color)",
                }),
              }}
              onClick={() => onStatusChange("NOT-FULFILLED")}
            />
          </>
        )}

        {config.source === "admin" && (
          <Input
            type="text"
            placeholder="Search by host name, phone, or order ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="host-search-input"
          />
        )}
      </div>
      {pageLoading ? (
        <PageLoader />
      ) : (
        <div>
          {filteredOrders &&
            filteredOrders.length > 0 &&
            filteredOrders.map((eachOrder, index) => (
              <div className="south-indian-restaurant-div row">
                <div className="fast-food-main-div col-lg-3 col-md-6">
                  <h5
                    className="fast-food-id"
                    style={{ textTransform: "uppercase" }}
                  >
                    ID: #{eachOrder.sequence_no}
                  </h5>
                  <h5>Order Type: {eachOrder.type}</h5>
                  <div className="line-break" />
                  <h5>Status: <span style={{ color: "var(--theme-primary-color)" }}>{selectedStatus === 'ACTIVE' ? eachOrder.status : eachOrder.quotationStatus}</span></h5>
                  <div className="line-break" />
                  <h6>Delivery Date and Time</h6>
                  <h6 style={{ color: "var(--theme-primary-color)" }}>
                    {new Date(eachOrder.date).toLocaleDateString("en-GB")} {" &  "}
                    {eachOrder?.time}
                  </h6>


                  <div className="host-details-section">
                    {config.source === "admin" ? (
                      <>
                        {restaurantId && restaurantId !== "all" ? (
                          // Specific restaurant selected
                          (() => {
                            const restaurantQuotation = eachOrder.quotations?.find((quotation) => {
                              const quotationRestaurantId = quotation.restaurant?._id || quotation.restaurant;
                              return quotationRestaurantId === restaurantId;
                            });

                            return restaurantQuotation ? (
                              <>
                                <h6 style={{ marginTop: "15px", marginBottom: "5px" }}>
                                  Selected Host Details:
                                </h6>
                                <p style={{ margin: "2px 0", fontSize: "14px" }}>
                                  <strong>Name:</strong>{" "}
                                  {restaurantQuotation.restaurant?.store_name || "No restaurant info"}
                                </p>
                                <p style={{ margin: "2px 0", fontSize: "14px" }}>
                                  <strong>Phone:</strong>{" "}
                                  {restaurantQuotation.restaurant?.primary_mobile_number || "No restaurant info"}
                                </p>
                                <PrimaryButton
                                  title="View Host Details"
                                  style={{
                                    marginTop: "10px",
                                    padding: "5px 10px",
                                    fontSize: "12px",
                                    background: "var(--theme-primary-color)",
                                  }}
                                  onClick={() => viewHostDetails(eachOrder)}
                                />
                              </>
                            ) : (
                              <p style={{ marginTop: "10px", fontSize: "14px", fontStyle: "italic" }}>
                                No host assigned from selected restaurant
                              </p>
                            );
                          })()
                        ) : (
                          // "All" restaurants selected
                          <>
                            <h6 style={{ marginTop: "15px", marginBottom: "5px" }}>Host Details:</h6>
                            {eachOrder.quotations && eachOrder.quotations.length > 0 ? (
                              <>
                                <p style={{ margin: "2px 0", fontSize: "14px" }}>
                                  <strong>Name:</strong>{" "}
                                  {eachOrder.quotations[0].restaurant?.store_name || "No restaurant info"}
                                </p>
                                <p style={{ margin: "2px 0", fontSize: "14px" }}>
                                  <strong>Phone:</strong>{" "}
                                  {eachOrder.quotations[0].restaurant?.primary_mobile_number || "No restaurant info"}
                                </p>
                                <PrimaryButton
                                  title="View Host Details"
                                  style={{
                                    marginTop: "10px",
                                    padding: "5px 10px",
                                    fontSize: "12px",
                                    background: "var(--theme-primary-color)",
                                  }}
                                  onClick={() => viewHostDetails(eachOrder)}
                                  disabled={!eachOrder.quotations[0].restaurant}
                                />
                              </>
                            ) : (
                              <p style={{ marginTop: "10px", fontSize: "14px", fontStyle: "italic" }}>
                                No host data present
                              </p>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      // Vendor view (existing code)
                      <>
                        {eachOrder.quotations && eachOrder.quotations.length > 0 ? (
                          <>
                            <h6 style={{ marginTop: "15px", marginBottom: "5px" }}>Host Details:</h6>
                            <p style={{ margin: "2px 0", fontSize: "14px" }}>
                              <strong>Name:</strong>{" "}
                              {eachOrder.quotations[0].restaurant?.store_name || "No restaurant info"}
                            </p>
                            <p style={{ margin: "2px 0", fontSize: "14px" }}>
                              <strong>Phone:</strong>{" "}
                              {eachOrder.quotations[0].restaurant?.primary_mobile_number || "No restaurant info"}
                            </p>
                            <PrimaryButton
                              title="View Host Details"
                              style={{
                                marginTop: "10px",
                                padding: "5px 10px",
                                fontSize: "12px",
                                background: "var(--theme-primary-color)",
                              }}
                              onClick={() => viewHostDetails(eachOrder)}
                              disabled={!eachOrder.quotations[0].restaurant}
                            />
                          </>
                        ) : (
                          <p style={{ marginTop: "10px", fontSize: "14px", fontStyle: "italic" }}>
                            No host data present
                          </p>
                        )}
                      </>
                    )}
                  </div>


                </div>
                <div className="paneer-kabab-main-div col-lg-3 col-md-6">
                  <h4 style={{ textAlign: "center", color: "#000" }}>
                    Menu Details
                  </h4>
                  <SimpleBar style={{ height: 220 }}>
                    {eachOrder.menu && eachOrder.menu.length > 0 ? (
                      eachOrder.menu.map((eachOrderItem, index) => (
                        <div className="paneer-kabab-div" key={index}>
                          <div className="green-doubt-div">
                            <span>
                              {index + 1}. {eachOrderItem.name}
                            </span>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                              <span>
                                {eachOrder.type === "ORDER"
                                  ? `Qty: ${eachOrderItem.quantity}`
                                  : `Persons: ${eachOrder.number_of_persons}`
                                }
                              </span>

                            </div>
                            {/* Payment Status */}
                            <div style={{
                              fontSize: '12px',
                              color: eachOrder.payment_status === 'PAID' ? 'green' : 'orange',
                              fontWeight: '600'
                            }}>
                              Payment: {eachOrder.payment_status === 'PARTIAL' ? 'PART PAID' : (eachOrder.payment_status || 'PENDING')}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No menu items available</p>
                    )}
                  </SimpleBar>
                </div>
                <div className="total-bill-external-div col-lg-3 col-md-6">
                  <h4 style={{ textAlign: "center" }}>Customer Details</h4>
                  <div className="customer-details">
                    <span className="fast-food-subheading color-black">
                      Customer Information
                    </span>
                    <p><strong>Name:</strong> {eachOrder.customer?.name || eachOrder.name || 'N/A'}</p>
                    <p><strong>Phone:</strong> {eachOrder.customer?.phone || eachOrder.mobile_no || 'N/A'}</p>
                    <p><strong>Email:</strong> {eachOrder?.email_address || 'N/A'}</p>
                    <p><strong>Address:</strong> {eachOrder.address?.full_address || '-'}</p>

                    <PrimaryButton
                      title="View Customer Info"
                      style={{
                        marginTop: '10px',
                        padding: '5px 10px',
                        fontSize: '12px',
                        background: "var(--theme-primary-color)"
                      }}
                      onClick={() => viewCustomerDetails(eachOrder)}
                    />
                  </div>
                </div>
                <div className="fast-food-delivery-main-div col-lg-3 col-md-6">
                  <h4 style={{ textAlign: "center", color: "#000" }}>
                    Actions
                  </h4>

                  {/* Order Timeline with actual timestamps */}
                  <div className="order-time-line" style={{ marginTop: 10 }}>
                    <div className="timeline-item">
                      <h6>Order Submitted</h6>
                      <div style={{ display: "flex", gap: "10px", alignItems: 'center' }}>
                        <span className="order-status-icon">
                          <i className="fa-solid fa-circle-check" />
                        </span>
                        <p style={{ fontSize: '12px' }}>
                          {moment(eachOrder.createdAt).format("Do MMM YYYY, HH:mm")}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="order-time-line" style={{ marginTop: 10 }}>
                    <div className="timeline-item">
                      <h6>Quotation Accepted</h6>
                      <div style={{ display: "flex", gap: "10px", alignItems: 'center' }}>
                        <span className="order-status-icon">
                          <i className="fa-solid fa-circle-check" />
                        </span>
                        <p style={{ fontSize: '12px' }}>
                          {eachOrder.acceptedAt ?
                            moment(eachOrder.acceptedAt).format("Do MMM YYYY, HH:mm") :
                            'Pending Acceptance'
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                  {!eachOrder.matched && selectedStatus === "ACTIVE" ? (
                    config.source === "vendor" && (
                      <PrimaryButton
                        title="Quotation"
                        style={{
                          marginTop: 40,
                        }}
                        onClick={() => onQuotationModal(eachOrder)}
                      />
                    )
                  ) : (
                    <>
                      <span>
                        Quotation Status:
                        <span
                          style={{
                            color: "#fff",
                            marginLeft: 10,
                            padding: 4,
                            background: "var(--theme-primary-color)",
                            borderRadius: 4,
                          }}
                        >
                          {eachOrder.quotationStatus}
                        </span>
                      </span>
                      <div className="quotation-details">
                        <span>Quotation Details:</span>
                        <p>
                          Quotation Amount:
                          <span
                            style={{
                              color: "var(--theme-primary-color)",
                              marginLeft: 10,
                            }}
                          >
                            {formatters.indianCurrency(eachOrder.amount || eachOrder.quotation?.amount)}
                          </span>
                        </p>
                        <p>
                          Description:
                          <span
                            style={{
                              color: "var(--theme-primary-color)",
                              marginLeft: 10,
                            }}
                          >
                            {eachOrder.description || eachOrder.quotation?.description}
                          </span>
                        </p>
                      </div>
                    </>
                  )}
                  <div className="order-time-line" style={{ marginTop: 20 }}>
                    <div style={{ display: "flex" }}>
                      <div className="each-time-line">
                        <h6>Placed</h6>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <span className="order-status-icon ">
                            <i class="fa-solid fa-circle-check" />
                          </span>
                          <p>
                            {moment(eachOrder?.createdAt).format(
                              "HH:mm A"
                            )}
                          </p>
                        </div>
                      </div>
                      {index < orderTimeline.length - 1 && (
                        <div className="timeline-line " />
                      )}
                    </div>
                  </div>
                  <div className="order-time-line" style={{ marginTop: 20 }}>
                    <div style={{ display: "flex" }}>
                      <div className="each-time-line">
                        <h6>Accepted</h6>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <span className="order-status-icon ">
                            <i class="fa-solid fa-circle-check" />
                          </span>
                          <p>
                            {moment(eachOrder?.address?.createdAt).format(
                              "HH:mm A"
                            )}
                          </p>
                        </div>
                      </div>
                      {index < orderTimeline.length - 1 && (
                        <div className="timeline-line " />
                      )}
                    </div>
                  </div>
                  {selectedStatus === "ACCEPTED" &&
                    config.source === "vendor" && (
                      <>
                      <PrimaryButton
                        title="Delivered"
                        onClick={() => onStatusModal(eachOrder)}
                        style={{ background: "var(--theme-primary-color)", marginBottom: 10 }}
                      />
                      </>
                    )}
                  {selectedStatus === "ACCEPTED" && (
                     <PrimaryButton
                        title="View Payments"
                        onClick={() => handleViewPayments(eachOrder)}
                        style={{ background: "#4CAF50" }}
                      />
                  )}
                </div>
              </div>
            ))}
          <div style={{ textAlign: "center", margin: "20px 0px 30px" }}>
            {partyOrders.length === 0 ? (
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: "var(--theme-primary-color)",
                }}
              >
                {partyOrderTotal === 0 ? "No Party Orders Found" : "No More Party Orders Found"}
              </p>
            ) : partyOrders.length < partyOrderTotal ? (
              <PrimaryButton
                title="Load More"
                loading={infiniteLoading}
                style={{ width: 150, background: "var(--theme-primary-color)" }}
                onClick={onLoadMore}
              />
            ) : null}
          </div>
        </div>
      )}
      <Modal show={quotationModal} onHide={() => onQuotationModal("")}>
        <ModalHeader closeButton>
          <ModalTitle>Add Quotation</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Formik
            key="quotation-form"
            initialValues={{
              description: "",
              amount: "",
              pricings: pricings,
            }}
            onSubmit={(values) => addQuotation(values)}
            validationSchema={validate.quotationSchema}
          >
            {({
              values,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              setFieldValue,
            }) => (
              <>
                {console.log(values)}
                {values.pricings.map((eachPricing, index) => (
                  <FormGroup
                    className="login-input-group"
                    style={{ display: "flex", marginTop: 20 }}
                  >
                    <div
                      style={{
                        width:
                          values.selectedPartyOrderType === "PERSON"
                            ? "95%"
                            : "60%",
                      }}
                    >
                      {index === 0 && <FormLabel>Pricing Type</FormLabel>}
                      <Input
                        type="text"
                        name={`pricings.${index}.priceType`}
                        onChange={(e) =>
                          onPriceTypeChange(
                            e,
                            setFieldValue,
                            "priceType",
                            eachPricing.id
                          )
                        }
                        value={values.pricings[index].priceType}
                        onBlur={handleBlur}
                        placeholder="Pricing Type"
                        className="customer-name-input"
                      />
                      {errors.pricings && errors.pricings[index] && (
                        <span className="error">
                          {errors.pricings[index].priceType}
                        </span>
                      )}
                    </div>

                    <div style={{ width: "25%", marginLeft: "25px" }}>
                      {index === 0 && <FormLabel>Amount</FormLabel>}
                      <Input
                        type="number"
                        name={`pricings.${index}.amount`}
                        onChange={(e) =>
                          onPriceTypeChange(
                            e,
                            setFieldValue,
                            "amount",
                            eachPricing.id
                          )
                        }
                        value={values.pricings[index].amount}
                        onBlur={handleBlur}
                        placeholder="Amount"
                        className="customer-name-input"
                      />
                      {errors.pricings && errors.pricings[index] && (
                        <span className="error">
                          {errors.pricings[index].amount}
                        </span>
                      )}
                    </div>

                    <div
                      style={{
                        width: "5%",
                        marginTop: index === 0 ? 15 : -10,
                        marginLeft: 20,
                      }}
                    >
                      <FormLabel></FormLabel>
                      {index === 0 ? (
                        <span
                          style={{
                            padding: "1px 10px",
                            background: "var(--theme-primary-color)",
                            color: "#fff",
                            cursor: "pointer",
                            borderRadius: 6,
                          }}
                          onClick={() => onAddPriceType(setFieldValue)}
                        >
                          +
                        </span>
                      ) : (
                        <span
                          style={{
                            padding: "1px 10px",
                            background: "var(--theme-primary-color)",
                            color: "#fff",
                            cursor: "pointer",
                            borderRadius: 6,
                          }}
                          onClick={() =>
                            onRemovePriceType(eachPricing, setFieldValue)
                          }
                        >
                          -
                        </span>
                      )}
                    </div>
                  </FormGroup>
                ))}
                {/* <FormGroup className="login-input-group">
                  <FormLabel>Amount*</FormLabel>
                  <Input
                    type="number"
                    name="amount"
                    onChange={handleChange}
                    value={values.amount}
                    onBlur={handleBlur}
                    placeholder="Amount"
                    className="customer-name-input"
                  />
                </FormGroup> */}
                {validate.displayError(touched, errors, "amount")}
                <FormGroup className="login-input-group">
                  <FormLabel>Description*</FormLabel>
                  <Input
                    as="textarea"
                    name="description"
                    onChange={handleChange}
                    value={values.description}
                    onBlur={handleBlur}
                    placeholder="description"
                    className="customer-name-input"
                    style={{ minHeight: 80 }}
                  />
                </FormGroup>
                {validate.displayError(touched, errors, "description")}
                <div className="bottom-btns">
                  <PrimaryButton
                    title="Submit"
                    style={{
                      borderColor: "var(--theme-primary-color)",
                      background: "var(--theme-primary-color)",
                      borderRadius: "5px",
                      padding: "15px 50px",
                      margin: "20px 5px",
                    }}
                    loading={quotationLoading}
                    onClick={handleSubmit}
                  />
                  <PrimaryButton
                    title="Cancel"
                    style={{
                      borderColor: "#e5e5e5",
                      background: "#e5e5e5",
                      borderRadius: "5px",
                      padding: "15px 50px",
                      color: "#000",
                      margin: "20px 5px",
                    }}
                    onClick={() => onQuotationModal("")}
                  />
                </div>
              </>
            )}
          </Formik>
        </ModalBody>
      </Modal>
      <Modal show={updateStatusModal} onHide={() => onStatusModal("")}>
        <ModalHeader closeButton>
          <ModalTitle>Update Deliver Status</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <p>Do you Update the Status of the order to be delivered?</p>
          <div className="bottom-btns">
            <PrimaryButton
              title="Delivered"
              style={{
                borderColor: "var(--theme-primary-color)",
                background: "var(--theme-primary-color)",
                borderRadius: "5px",
                padding: "15px 50px",
                margin: "20px 5px",
              }}
              loading={quotationLoading}
              onClick={deliveredPartyOrderQuotation}
            />
            <PrimaryButton
              title="Cancel"
              style={{
                borderColor: "#e5e5e5",
                background: "#e5e5e5",
                borderRadius: "5px",
                padding: "15px 50px",
                color: "#000",
                margin: "20px 5px",
              }}
              onClick={() => onStatusModal("")}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Payments Modal */}
      <Modal show={paymentsModal} onHide={() => setPaymentsModal(false)} size="lg">
        <ModalHeader closeButton>
          <ModalTitle>Payment Distributions</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {selectedPartyOrder && (
            <div style={{ marginBottom: 15 }}>
               <h6>Payment Summary</h6>
               <p><strong>Total Amount:</strong> {formatters.indianCurrency(selectedPartyOrder.quotation?.amount || selectedPartyOrder.amount)}</p>
               <p><strong>Amount Paid:</strong> {formatters.indianCurrency(selectedPartyOrder.amount_paid || 0)}</p>
               <p><strong>Amount Due:</strong> {formatters.indianCurrency(selectedPartyOrder.amount_due || (selectedPartyOrder.quotation?.amount || selectedPartyOrder.amount))}</p>
            </div>
          )}
          {paymentDistributions && paymentDistributions.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Gateway</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paymentDistributions.map((dist, idx) => (
                  <tr key={idx}>
                    <td>{moment(dist.createdAt).format("DD MMM YYYY, HH:mm")}</td>
                    <td>{dist.gateway}</td>
                    <td>{formatters.indianCurrency(dist.amount)}</td>
                    <td>
                      <span className={`status-badge ${dist.status?.toLowerCase()}`}>{dist.status}</span>
                    </td>
                    <td>
                      {dist.status === 'PENDING' && (dist.gateway === 'CASH' || dist.gateway === 'TRANSFER') && (
                        <PrimaryButton
                          title="Confirm"
                          onClick={() => handleApproveOfflinePayment(dist._id)}
                          style={{ padding: '5px 10px', fontSize: '12px', background: 'var(--theme-primary-color)' }}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No payment distributions found.</p>
          )}
        </ModalBody>
      </Modal>

      {/* Host Details Modal */}
      <Modal show={hostDetailsModal} onHide={() => setHostDetailsModal(false)} size="lg">
        <ModalHeader closeButton>
          <ModalTitle>Host Details - {selectedHost?.store_name}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {selectedHost && (
            <div className="host-details-modal">
              <div className="row">
                <div className="col-md-6">
                  <h6>Basic Information</h6>
                  <p><strong>Store Name:</strong> {selectedHost.store_name || 'N/A'}</p>
                  <p><strong>Contact Name:</strong> {selectedHost.contact_name || 'N/A'}</p>
                  <p><strong>Primary Mobile:</strong> {selectedHost.primary_mobile_number || 'N/A'}</p>
                  <p><strong>Store Phone:</strong> {selectedHost.store_phone || 'N/A'}</p>
                  <p><strong>Email:</strong> {selectedHost.email || 'N/A'}</p>
                  <p><strong>Status:</strong> <span className={`status-badge ${selectedHost.status?.toLowerCase()}`}>{selectedHost.status || 'N/A'}</span></p>
                </div>

                <div className="col-md-6">
                  <h6>Business Details</h6>
                  <p><strong>Registration Number:</strong> {selectedHost.registration_number || 'N/A'}</p>
                  <p><strong>VAT Number:</strong> {selectedHost.vat_number || 'N/A'}</p>
                  <p><strong>Settlement Frequency:</strong> {selectedHost.settlement_frequency || 'N/A'}</p>
                  <p><strong>Verified Host:</strong> {selectedHost.verified_host || 'No'}</p>
                  <p><strong>Visibility:</strong> {selectedHost.visibility || 'N/A'}</p>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <h6>Service Options</h6>
                  <p><strong>Delivery:</strong> {selectedHost.delivery || 'No'}</p>
                  <p><strong>Pickup:</strong> {selectedHost.pickup || 'No'}</p>
                  <p><strong>Eat-in:</strong> {selectedHost.eat_in || 'No'}</p>
                  <p><strong>Drive-in:</strong> {selectedHost.drive_in || 'No'}</p>
                  <p><strong>Book a Table:</strong> {selectedHost.book_a_table || 'No'}</p>
                  <p><strong>Cash on Delivery:</strong> {selectedHost.cash_on_delivery || 'No'}</p>
                </div>

                <div className="col-md-6">
                  <h6>Store Information</h6>
                  <p><strong>About Store:</strong> {selectedHost.about_store || 'N/A'}</p>
                  <p><strong>Contact Address:</strong> {selectedHost.contact_address || 'N/A'}</p>
                  <p><strong>Show Tax:</strong> {selectedHost.show_tax === "1" ? 'Yes' : 'No'}</p>
                  <p><strong>Online Status:</strong> {selectedHost.online || 'No'}</p>
                </div>
              </div>

              {/* <div className="row mt-3">
          <div className="col-12">
            <h6>Store Timings</h6>
            {selectedHost.timings && Object.entries(selectedHost.timings).map(([day, schedule]) => (
              <div key={day} className="timing-item">
                <strong>{day.charAt(0).toUpperCase() + day.slice(1)}:</strong> 
                {schedule.holiday ? ' Holiday' : 
                 schedule.timing && schedule.timing.length > 0 ? 
                 schedule.timing.map((slot, index) => (
                   <span key={index}> {slot.open} - {slot.close}</span>
                 )) : ' Closed'}
              </div>
            ))}
          </div>
        </div> */}

              {selectedHost.cuisine && selectedHost.cuisine.length > 0 && (
                <div className="row mt-3">
                  <div className="col-12">
                    <h6>Cuisine Specialties</h6>
                    <div className="cuisine-tags">
                      {selectedHost.cuisine.map((cuisine, index) => (
                        <span key={index} className="cuisine-tag">{cuisine}</span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </ModalBody>
      </Modal>

      {/* Customer Details Modal */}
      <Modal show={customerDetailsModal} onHide={() => setCustomerDetailsModal(false)} size="lg">
        <ModalHeader closeButton>
          <ModalTitle>Customer Details - {selectedCustomer?.name}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {selectedCustomer && (
            <div className="customer-details-modal">
              <div className="row">
                <div className="col-md-6">
                  <h6>Personal Information</h6>
                  <p><strong>Name:</strong> {selectedCustomer.name || 'N/A'}</p>
                  <p><strong>Phone:</strong> {selectedCustomer.mobile_no || selectedCustomer.phone || 'N/A'}</p>
                  <p><strong>Email:</strong> {selectedCustomer.email_address || selectedCustomer.email || 'N/A'}</p>
                  <p><strong>Order Type:</strong> {selectedCustomer.type || 'N/A'}</p>
                  <p><strong>Number of Persons:</strong> {selectedCustomer.number_of_persons || 'N/A'}</p>
                </div>

                <div className="col-md-6">
                  <h6>Order Information</h6>
                  <p><strong>Order ID:</strong> {selectedCustomer.sequence_no || 'N/A'}</p>
                  <p><strong>Order Status:</strong> <span className={`status-badge ${selectedCustomer.status?.toLowerCase()}`}>{selectedCustomer.status || 'N/A'}</span></p>
                  <p><strong>Payment Status:</strong> <span className={`status-badge ${selectedCustomer.payment_status?.toLowerCase()}`}>{selectedCustomer.payment_status || 'N/A'}</span></p>
                  <p><strong>Delivery Date:</strong>
                    {selectedCustomer.date
                      ? moment(selectedCustomer.date).format("MM/DD/YYYY")
                      : 'N/A'} {" "}
                    {selectedCustomer.time || ''}</p>
                  <p><strong>Order Created:</strong> {selectedCustomer.createdAt ? moment(selectedCustomer.createdAt).format("MMMM Do YYYY, HH:mm A") : 'N/A'}</p>
                </div>
              </div>

              {/* Address Details */}
              {selectedCustomer.address && (
                <div className="row mt-3">
                  <div className="col-12">
                    <h6>Delivery Address</h6>
                    <div className="address-card">
                      <p><strong>Full Address:</strong> {selectedCustomer.address.full_address || 'N/A'}</p>
                      <div className="row">
                        <div className="col-md-3">
                          <p><strong>House No:</strong> {selectedCustomer.address.house_no || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>Building:</strong> {selectedCustomer.address.building_name || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>Street:</strong> {selectedCustomer.address.street_name || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>Landmark:</strong> {selectedCustomer.address.land_mark || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <p><strong>Area:</strong> {selectedCustomer.address.area || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>City:</strong> {selectedCustomer.address.city || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>County:</strong> {selectedCustomer.address.county || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>State:</strong> {selectedCustomer.address.state || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <p><strong>Pincode:</strong> {selectedCustomer.address.pincode || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>Address Type:</strong> {selectedCustomer.address.type_of_address || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>Phone:</strong> {selectedCustomer.address.phone_number || 'N/A'}</p>
                        </div>
                        <div className="col-md-3">
                          <p><strong>Status:</strong> <span className={`status-badge ${selectedCustomer.address.status?.toLowerCase()}`}>{selectedCustomer.address.status || 'N/A'}</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Menu Details */}
              {selectedCustomer.menu && selectedCustomer.menu.length > 0 && (
                <div className="row mt-3">
                  <div className="col-12">
                    <h6>Order Items</h6>
                    <div className="menu-items-list">
                      {selectedCustomer.menu.map((item, index) => (
                        <div key={index} className="menu-item-card">
                          <div className="row">
                            <div className="col-md-6">
                              <p><strong>{index + 1}. {item.name || 'Unnamed Item'}</strong></p>
                            </div>
                            <div className="col-md-3">
                              <p><strong>Quantity:</strong> {item.quantity || selectedCustomer.number_of_persons || '1'}</p>
                            </div>
                            <div className="col-md-3">
                              <p><strong>Type:</strong> {selectedCustomer.type === "ORDER" ? "Order" : "Per Person"}</p>
                            </div>
                          </div>
                          {item.description && (
                            <p><strong>Description:</strong> {item.description}</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Special Instructions */}
              {selectedCustomer.delivery_instructions && (
                <div className="row mt-3">
                  <div className="col-12">
                    <h6>Special Instructions</h6>
                    <div className="instructions-card">
                      <p>{selectedCustomer.delivery_instructions}</p>
                    </div>
                  </div>
                </div>
              )}

            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
}
